export default __webpack_public_path__ + "static/media/penetratingshot2.bc507aa6.png";